import React from 'react';
import { isContain } from '../../util/common';
class MarqueeCom extends React.Component {
    constructor(props){
        super(props);
        this.autoMarquee = this.autoMarquee.bind(this);
        this.isMarquee = this.isMarquee.bind(this);
    }

    autoMarquee(eid,scolltype, height, scrollSpeed, ebaseid) {
            // this.addMarqueeAttrs(eid,scolltype,height);
            $("#titleContainer_"+eid).css({'position':'relative','z-index':'1','background-color':'white'})
            let div = $("#content_"+eid +" .ant-spin-container")[1];
            let div2 = $("#content_"+eid +" .ant-spin-container")[0];
            if(!div && !div2){
                return ;
            }
            if(!div){
                div = div2
            }

            if(ebaseid && ebaseid == 'notice'){
                div = $("#content_"+eid +" .newnotice-add-Carousel")[0];
            }

            let offsetWidth = parseInt(div.offsetWidth)
            let offsetHeight = parseInt($("#tabcontant_"+eid)[0].offsetHeight)

            div.style.left = 0;
            div.style.top = 0;
        if(this.isMarquee(scolltype)){
            if(scolltype == 'right'){
                div.style.left = -offsetWidth+"px"
                this.myInterval = setInterval( function  (){

                    let left = parseInt(div.style.left.split("px")[0]);
                    if(left >= offsetWidth ){
                        div.style.left = -div.offsetWidth+"px"
                    }else{
                        const i = (div.style.left+"").split('px')[0]
                        div.style.left = parseInt(i)+1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'left'){
                div.style.left = offsetWidth+"px"
                this.myInterval = setInterval( function  (){

                    let left = parseInt(div.style.left.split("px")[0])
                    if(left <=-offsetWidth ){
                        div.style.left = div.offsetWidth+"px"
                    }else{
                        const i = (div.style.left+"").split('px')[0]
                        div.style.left = parseInt(i)-1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'up'){
                $('.homepage').find(`#content_view_id_${eid}`).css("overflow-y", "hidden")
                div.style.top = offsetHeight+"px";
                this.myInterval = setInterval( function  (){

                    let top = parseInt(div.style.top.split("px")[0])
                    if(top <=-offsetHeight ){
                        div.style.top = div.offsetHeight+"px"
                    }else{
                        const i = (div.style.top+"").split('px')[0]
                        div.style.top = parseInt(i)-1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'down'){
                $('.homepage').find(`#content_view_id_${eid}`).css("overflow-y", "hidden")
                div.style.top = -offsetHeight+"px"
                this.myInterval = setInterval( function  (){

                    let top = parseInt(div.style.top.split("px")[0])
                    if(top >=offsetHeight){
                        div.style.top = -div.offsetHeight+"px"
                    }else{
                        const i = (div.style.top+"").split('px')[0]
                        div.style.top = parseInt(i)+1+"px"
                    }
                }.bind(this),scrollSpeed)
            }
        }else {
            $('.homepage').find(`#content_view_id_${eid}`).css("overflow-y", "auto")
        }
        div.onmouseover = () => {
            clearInterval(this.myInterval)
        };
        div.onmouseout = () =>{
            let div = $("#content_"+eid +" .ant-spin-container")[1];
            if(ebaseid && ebaseid == 'notice'){
                div = $("#content_"+eid +" .newnotice-add-Carousel")[0];
            }
            if(scolltype == 'right'){
                this.myInterval = setInterval( function  (){

                    let left = parseInt(div.style.left.split("px")[0])
                    if(left >= offsetWidth ){
                        div.style.left = -div.offsetWidth+"px"
                    }else{
                        const i = (div.style.left+"").split('px')[0]
                        div.style.left = parseInt(i)+1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'left'){
                this.myInterval = setInterval( function  (){

                    let left = parseInt(div.style.left.split("px")[0])
                    if(left <=-offsetWidth ){
                        div.style.left = div.offsetWidth+"px"
                    }else{
                        const i = (div.style.left+"").split('px')[0]
                        div.style.left = parseInt(i)-1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'up'){
                this.myInterval = setInterval( function  (){

                    let top = parseInt(div.style.top.split("px")[0])
                    if(top <=-offsetHeight){
                        div.style.top = div.offsetHeight+"px"
                    }else{
                        const i = (div.style.top+"").split('px')[0]
                        div.style.top = parseInt(i)-1+"px"
                    }
                }.bind(this),scrollSpeed)
            }else if(scolltype == 'down'){
                this.myInterval = setInterval( function  (){

                    let top = parseInt(div.style.top.split("px")[0])
                    if(top >=offsetHeight){
                        div.style.top = -div.offsetHeight+"px"
                    }else{
                        const i = (div.style.top+"").split('px')[0]
                        div.style.top = parseInt(i)+1+"px"
                    }
                }.bind(this),scrollSpeed)
            }
        };
    }
    componentDidMount() {
        const {eid,scolltype, height,tabdata, scrollSpeed = '20', ebaseid} = this.props;
        if(tabdata && tabdata.data && tabdata.data.length == 0 ){
            this.autoMarquee(eid,"none", height, scrollSpeed);
        }else{
            this.autoMarquee(eid,scolltype, height, scrollSpeed, ebaseid);
        }
    }

    componentDidUpdate(){
        const { eid,scolltype, height,tabdata, scrollSpeed = '20', ebaseid  }  = this.props;
        clearInterval(this.myInterval);
        if(tabdata && tabdata.data && tabdata.data.length == 0 ){
            this.autoMarquee(eid,"none", height, scrollSpeed);
        }else{
            this.autoMarquee(eid,scolltype, height, scrollSpeed, ebaseid);
        }

    }
    componentWillUnmount(){

        const {scolltype } = this.props;
        if(this.isMarquee(scolltype)){
            clearInterval(this.myInterval);
        }
    }
    isMarquee(scolltype){
        const arr = ['up','down','left','right'];
        return isContain(arr, scolltype);
    }
    addMarqueeAttrs(eid, scolltype,height) {
		var attrs = {
            direction: scolltype,
            onmouseover: 'this.stop()',
            onmouseout: 'this.start()',
            scrolldelay: '200'
        };
        if (scolltype === 'up' || scolltype === 'down') {
            attrs['width'] = '100%';
            attrs['height'] = height;
        }
        $("#webjx_" + eid).attr(attrs);
    }
    render() {
        const { eid, children, scolltype,height, ebaseid } = this.props;
        if(this.isMarquee(scolltype)){
            //return <marquee id={`webjx_${eid}`}> { children } </marquee>
            if(ebaseid && ebaseid == 'notice'){
                return  <div  style={{position:'relative',display:'inline-block', width: '100%', overflow: 'hidden'}}>{children}</div>
            }
            return  <div  style={{position:'relative',display:'inline-block', width: '100%'}}>{children}</div>
        }else return <div>{children}</div>;
    }
}
export default MarqueeCom;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/MarqueeCom.js